import React, { Component } from 'react';

class BarTitle extends Component {

    render() {
        // return (
        //     <div className="bg-light lter b-b wrapper-md bar-little">
        //         <div className="row">
        //             <div className="col-sm-6 col-xs-12">
        //                 <h1 className="m-n font-thin h3 text-black">{this.props.name}</h1>
        //                 <small className="text-muted">{this.props.subTitle}</small>
        //             </div>
        //         </div>
        //     </div>
        // );

        return (
            <div className="bg-light lter b-b wrapper-md bar-little">
                <div className="row">
                    <div className="col-sm-6 col-xs-12">
                        <h3>{this.props.name}</h3>
                        <small className="text-muted">{this.props.subTitle}</small>
                    </div>
                </div>
            </div>
        );
    }
}

export default BarTitle;



// WEBPACK FOOTER //
// ./src/components/BarTitle/index.js